import React, { useState, useEffect, useCallback } from "react";
import { EmployeeNavbar } from "../reusedcomponent/navbar";
import ViewDetailModal from "../modals/view_details";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../../components/confirm";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { PageBody } from "../../../../components/loader";
import { constant } from "../../../../Constants/constant";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
    width: "1000px",
    height: "100vh",

    // border: "2px solid green",
  },
};

export const EmployeeInactive = () => {
  const history = useHistory();
  const alert = useAlert();
  const [modalopen, Setmodalopen] = useState(false);
  const [users, setUsers] = useState([]);
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [employee, setEmployee] = useState();
  const [open, setOpen] = useState();

  const { inActives } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  const close = () => {
    setOpen(false);
  };

  const getInActiveEmployees = useCallback(async () => {
    updateLoader(true, "Getting all in active employees");
    await dispatch(employeeMngtThunk.getInactiveEmployees());
    updateLoader(false);
  }, [dispatch]);

  const Activate = (slug) => {
    const request = async () => {
      const user_id = {
        slug: slug,
      };
      const res = await ApiService.post(`users/activate/${slug}`, user_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getInActiveEmployees();
        history.push("/dashboard/employee");
      }
    };
    ConfirmTemplate(
      {
        title: "Activate User",
        message: "Are You Sure You Want To Activate This User",
      },
      request
    );
  };

  useEffect(() => {
    getInActiveEmployees();
  }, []);

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <EmployeeNavbar />
        <Modal
          isOpen={open}
          onRequestClose={close}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <ViewDetailModal closeModal={close} user={employee} />
        </Modal>
        {/* <ViewDetailModal toggle={toggle} modal={modalopen} /> */}
        <div className="row container">
          {inActives.map((employee, i) => (
            <div className="col-md-3" key={i}>
              <div className="text-center card-box-two">
                {/* {user.data.user.roles &&
                user.data.user.roles.name === "admin" ? ( */}
                <div className="dropdown pull-right">
                  <a
                    href="employee-management.html#"
                    className="dropdown-toggle card-drop arrow-none"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <h3 className="m-0 text-muted">
                      <i className="fas fa-ellipsis-v"></i>
                    </h3>
                  </a>

                  <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="btnGroupDrop1"
                  >
                    <Link
                      to={`/dashboard/employee/edit/${employee.slug}`}
                      className="dropdown-item"
                    >
                      Edit
                    </Link>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        Activate(employee.slug);
                      }}
                    >
                      Activate
                    </button>
                  </div>
                </div>
                {/* ) : null} */}

                <div className="clearfix"></div>
                <div className="member-card">
                  <div className="thumb-xl member-thumb m-b-10 mx-auto">
                    <img
                      src={`${constant.ImgURL}/uploads/${employee.profile_picture}`}
                      className="rounded-circle img-thumbnail"
                      alt="profile"
                    />
                    <i
                      className="mdi mdi-star-circle member-star text-danger"
                      title="verified user"
                    ></i>
                  </div>

                  <div className="">
                    <h4 className="m-b-5 font-18">
                      {employee.first_name + " " + employee.last_name}
                    </h4>
                    <p className="text-muted">
                      {employee.job_title !== null
                        ? employee.job_title.name
                        : ""}{" "}
                      <span> || </span> <span> {employee.office}</span>
                    </p>
                  </div>

                  <p className="text-muted font-13">{employee.mobile_number}</p>
                  <p className="text-muted font-13">
                    {employee.is_active ? "Active" : "Inactive"}{" "}
                  </p>
                  <button
                    type="button"
                    className="btn btn-primary m-t-20 btn-rounded btn-bordered waves-effect w-md waves-light"
                    onClick={() => {
                      setOpen(true);
                      setEmployee(employee);
                    }}
                  >
                    View details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/employees/inactive_employee.js